import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
import { ApiResponse, LatLng, PartnersLocation, InterpreterProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { IInterpreterService } from '../iInterpreterService';

export class InterpreterService implements IInterpreterService {
    public async getInterpreterList(baseURL: string, interpreterRequest: QueryRecordsRequest):
    Promise<ApiResponse<InterpreterProfile[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: interpreterRequest.conditions ? interpreterRequest.conditions : [],
            limit: interpreterRequest.limit  ? interpreterRequest.limit : MedTransGoConstants.PAGINATION_LIMIT,
            start: interpreterRequest.start ? interpreterRequest.start : 0,
        };
        const apiRequest: ApiRequest = {
            baseURL,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_INTERPRETERS}/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<InterpreterProfile[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }
}
